import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Formik } from "formik";
import {
  createTheme,
  Divider,
  FormHelperText,
  Grid2,
  IconButton,
  TextField,
  ThemeProvider,
  Typography,
  useTheme,
  Grid,
} from "@mui/material";
import * as Yup from "yup";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useEditKeyPMMutation } from "store/slices/apis/keyPMSlice";
import {ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"

// const Statuses = [
//   { label: "True", value: true },
//   { label: "False", value: false },
// ];

export default function EditPM(props) {
  const {
    open,
    cancelIssue,
    openNotification,
    data,
    isViewIssueModal,
    refetch,
  } = props;
  const newtheme = useTheme();
  const { projectId } = useParams();
  const [files, setFiles] = useState([]);
  const [editKeyPM, { isLoading }] = useEditKeyPMMutation();

  const [formData, setFormData] = useState({
    consultant_contractor: data?.consultant_contractor,
    type_of_PM: data?.type_of_PM,
    plan_date: data?.plan_date,
    quantity: data?.quantity,
    actual_date: data?.actual_date,
    owned: data?.owned,
    PM_type: data?.PM_type,
    comment: data?.comment,
  });

  const theme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            border: "2px solid #e6e6e6",
            "& .MuiFilledInput-input": {
              backgroundColor: "#fff",
              color: "#252525",
              fontSize: "16px",
            },
            "& .MuiFilledInput-root::before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root::after": {
              borderBottom: `2px solid ${newtheme?.customSettings?.themeColor}`,
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#696969",
              fontSize: "14px",
            },
            "& .MuiFormLabel-root": {
              fontSize: "15px",
            },
            "& .MuiFilledInput-root.Mui-disabled:before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root": {
              backgroundColor: "#fff",
            },
            "& .MuiFilledInput-input": {
              backgroundColor: "none",
              fontSize: "14px",
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#696969",
            },
            "& .MuiFilledInput-root.Mui-disabled": {
              backgroundColor: "#fff",
              color: "inherit",
            },
            "& .MuiFilledInput-input.Mui-disabled": {
              WebkitTextFillColor: "#696969",
              opacity: "none",
            },
          },
        },
      },
    },
  });

  const handleClose = () => {};

  const validationSchema = Yup.object({
    actual_date: Yup.date()
      .required("Actual Expected Date is required")
      .nullable()
      .typeError("Actual Expected Date must be a valid date"),
  });

  const handleDrop = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      openNotification("File type must be image/*");
      return;
    }
    const newFiles = acceptedFiles.filter(
      (file) => !files.some((f) => f.name === file.name)
    );

    if (newFiles.length > 0) {
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
  };

  const handleRemoveFile = (fileName) => {
    setFiles(files.filter((file) => file.name !== fileName));
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    let reqBody = {
      consultant_contractor: data?.consultant_contractor,
      type_of_PM: values.type_of_PM,
      plan_date: new Date(values.plan_date).toISOString(),
      quantity: values.quantity,
      actual_date: new Date(values.actual_date).toISOString(),
      owned: values.owned,
      PM_type: values.PM_type,
      comment: values.comment,
      ProjectId: projectId,
      id: data?.id,
      pm_number: data?.pm_number,
      project: data?.project,
      version: data?.version,
      status: data?.status,
      approved_status: data?.approved_status,
      active: data?.active,
      date: data?.date,
      pm_reporting_date: data?.pm_reporting_date,
      updatedate: data?.updatedate,
      createdby: data?.createdby,
      updatedby: data?.updatedby,
    };

    try {
      const formData = new FormData();
      formData.append("pandmJson", JSON.stringify({ ...reqBody }));
      // formData.append("file", files);
      const response = await editKeyPM({
        id: data?.id,
        body: formData,
      }).unwrap();
      if (response?.status == "Success") {
        openNotification(response?.message, "success");
        resetForm();
        refetch();
        cancelIssue();
      } else {
        openNotification("Error in p-and-m updation");
      }
    } catch (error) {
      console.log("errr", error);

      openNotification(error?.data?.message, "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            overflowY: "inherit",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "20px", color: "#696969" }}>
          {isViewIssueModal ? "View" : "Edit"} Plant & Machinery
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancelIssue}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
             {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
          <CrossIcon style={{ fontSize: "20px", width:"20px", height:"20px", fill:"#808080" }} />
        </IconButton>
        <Divider sx={{ w: 1 }} />
        <DialogContent>
          <ThemeProvider theme={theme}>
            <Box sx={{ mt: 1 }}>
              <Formik
                initialValues={formData}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                  setTouched,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography
                          variant="h4"
                          gutterBottom
                          sx={{ fontSize: "20px", color: "#252525" }}
                        >
                          {isViewIssueModal
                            ? "Plant & Machinery Details"
                            : "Enter Plant & Machinery Details"}
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          label="Consultant Contractor"
                          name="consultant_contractor"
                          fullWidth
                          value={values?.consultant_contractor}
                          onChange={handleChange}
                          variant="filled"
                          disabled={true}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          label="PM Name"
                          name="type_of_PM"
                          fullWidth
                          value={values?.type_of_PM}
                          onChange={handleChange}
                          variant="filled"
                          disabled={true}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          type="date"
                          label="Plan Deployment Date"
                          name="plan_date"
                          fullWidth
                          value={
                            values?.plan_date
                              ? values.plan_date.split("T")[0]
                              : ""
                          }
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, plan_date: true })
                          }
                          variant="filled"
                          disabled={true}
                          inputProps={{
                            style: { height: "24px" },
                          }}
                          InputLabelProps={{
                            style: { fontSize: 12, fontWeight: 400 },
                          }}
                          placeholder="mm/dd/yyyy"
                          sx={{
                            input: {
                              "&::placeholder": {
                                fontSize: 16,
                                fontWeight: 400,
                              },
                            },
                            "& .MuiFormLabel-asterisk": {
                              color: "red",
                              fontSize: 20,
                            },
                          }}
                          slotProps={{ inputLabel: { shrink: true } }}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                        {touched?.plan_date && errors?.plan_date && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.plan_date}`}</FormHelperText>
                        )}
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          label="Quantity"
                          name="quantity"
                          fullWidth
                          value={values?.quantity}
                          onChange={handleChange}
                          variant="filled"
                          disabled={true}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          type="date"
                          label="Actual Deployment Date"
                          name="actual_date"
                          fullWidth
                          value={
                            values?.actual_date
                              ? values.actual_date.split("T")[0]
                              : ""
                          }
                          onChange={handleChange}
                          variant="filled"
                          disabled={isViewIssueModal}
                          inputProps={{
                            style: { height: "24px" },
                            // min: new Date().toISOString().split("T")[0],
                          }}
                          InputLabelProps={{
                            style: { fontSize: 12, fontWeight: 400 },
                          }}
                          placeholder="mm/dd/yyyy"
                          sx={{
                            input: {
                              "&::placeholder": {
                                fontSize: 16,
                                fontWeight: 400,
                              },
                            },
                            "& .MuiFormLabel-asterisk": {
                              color: "red",
                              fontSize: 20,
                            },
                          }}
                          slotProps={{ inputLabel: { shrink: true } }}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        {/* <Autocomplete
                          options={Statuses}
                          disabled={true}
                          getOptionLabel={(option) => option?.label}
                          value={
                            Statuses.find(
                              (option) => option.value === values?.owned
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "owned",
                              newValue ? newValue.label : ""
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Owned"
                              name="owned"
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        /> */}
                        <TextField
                          label="Owned"
                          name="owned"
                          fullWidth
                          value={values?.owned ? "True" : "False"}
                          onChange={handleChange}
                          variant="filled"
                          disabled={true}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          label="PM Type"
                          name="PM_type"
                          fullWidth
                          value={values?.PM_type}
                          onChange={handleChange}
                          variant="filled"
                          disabled={true}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          label="Comment"
                          name="comment"
                          fullWidth
                          multiline
                          value={values?.comment}
                          onChange={handleChange}
                          variant="filled"
                          disabled={true}
                        />
                      </Grid>

                      {/* <Grid item xs={12}>
                        <TextField
                          label="Current Status"
                          name="current_status"
                          fullWidth
                          multiline
                          value={values?.current_status}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, current_status: true })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.current_status && errors?.current_status && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.current_status}`}</FormHelperText>
                        )}
                      </Grid> */}

                      {/* <Grid2 size={12}>
                                                {issueDetail?.data?.files?.length > 0 &&
                                                    <>
                                                        <List dense={dense}>
                                                            {issueDetail?.data?.files?.map((file, index) => (
                                                                <ListItem
                                                                    key={index}
                                                                    sx={{ padding: 0 }}
                                                                    secondaryAction={
                                                                        <IconButton edge="end" aria-label="delete" role="link" onClick={() => handleRemoveFile(index)}>
                                                                            <RxCross2 />
                                                                        </IconButton>
                                                                    }
                                                                >
                                                                    <ListItemAvatar>
                                                                        <Avatar sx={{ background: 'none' }}>
                                                                            <FaRegFileLines fontSize="inherit" style={{ color: '#474747' }} />
                                                                        </Avatar>
                                                                    </ListItemAvatar>
                                                                    <ListItemText
                                                                        primary={
                                                                            <span
                                                                                style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                                                                                onClick={() => {
                                                                                    window.open(`${API_END_POINT}${file?.name}`, "_blank");
                                                                                }}
                                                                            >
                                                                                {file?.name}
                                                                            </span>
                                                                        }
                                                                        secondary={secondary ? 'Secondary text' : null}
                                                                    />
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                    </>
                                                }
                                            </Grid2> */}

                      {/* <Grid item xs={12}>
                        {files.length > 0 && (
                          <>
                            <Typography
                              variant="h6"
                              gutterBottom
                              style={{
                                color: "#474747",
                                fontWeight: "400",
                                fontSize: "16px",
                              }}
                            >
                              Uploaded Files
                            </Typography>

                            <List dense>
                              {files.map((file, index) => (
                                <ListItem
                                  key={index}
                                  sx={{
                                    padding: 0,
                                  }}
                                  secondaryAction={
                                    <IconButton
                                      edge="end"
                                      aria-label="delete"
                                      onClick={() =>
                                        handleRemoveFile(file.name)
                                      }
                                    >
                                      <RxCross2 />
                                    </IconButton>
                                  }
                                >
                                  <ListItemAvatar>
                                    <Avatar sx={{ background: "none" }}>
                                      <FaRegFileLines
                                        fontSize="inherit"
                                        style={{ color: "#474747" }}
                                      />
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText primary={`${file.name}`} />
                                </ListItem>
                              ))}
                            </List>
                          </>
                        )}
                      </Grid> */}
                      {/* {!isViewIssueModal && (
                        <Grid item xs={12}>
                          <DragAndDropUpload
                            onDrop={handleDrop}
                            multi={true}
                            fileType="both"
                          />
                        </Grid>
                      )} */}
                      <Grid item xs={12}>
                        {/* <Button
                          onClick={cancelIssue}
                          variant="outlined"
                          sx={{
                            color: `${newtheme?.customSettings?.themeColor}`,
                            border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                            padding: "6px 20px",
                            fontWeight: "500",
                            textTransform: "none",
                            float: "right",
                            fontSize: "16px",
                            marginBottom: "20px",
                          }}
                        >
                          Cancel
                        </Button> */}
                        {!isViewIssueModal && (
                          <Button
                            type="submit"
                            loading={isLoading}
                            variant="contained"
                            sx={{
                              marginRight: "20px",
                              backgroundColor: `${newtheme?.customSettings?.themeColor}`,
                              color: "#FFF",
                              padding: "6px 20px",
                              fontWeight: "500",
                              textTransform: "none",
                              float: "right",
                              fontSize: "16px",
                            }}
                          >
                            Edit P&M
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </Box>
          </ThemeProvider>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
